// extracted by mini-css-extract-plugin
export default {"button":"I+bBR","link":"+L-WU","mobileLink":"uBS+9","description":"bjvWV","expanded":"W+gOq"};